import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Stack from '@mui/material/Stack';
import { Avatar, Card, Grid } from '@mui/material';
import AsyncSelect from "react-select/async";
import { useEffect } from 'react';
import { ProjectIdContext } from '../contexts/Project/Project';
import { useForm } from 'react-hook-form';
import { Project} from '../api/Endpoints/Project';


export default function ButtonAppBar() {
    const { register, handleSubmit, watch, formState: { errors }, control, setValue, getValues, reset } = useForm();

    const { ProjectID, ProjectName,setProjectID,setProjectName } = ProjectIdContext()

    const fetchProject = (e) => {
        return Project.get({ keyword: e}).then((response) => {
            if (typeof response.data.data.data !== "undefined") {
                return response.data.data.data
            } else {
                return []
            }
        })
    }

    useEffect(() => {
        setValue('domain_name', { id: ProjectID, name: ProjectName })
    }, [ProjectID])

    const handleUserSelect=(data)=>{
        console.log(data);
        console.log(watch('doamin_name'), ProjectID, ProjectName);
        setProjectID(data.id)
        setProjectName(data.name)
    }

    console.log(watch('doamin_name'), ProjectID, ProjectName);

    return (
        <Box sx={{ flexGrow: 1, backgroundColor: 'white', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>

            <AppBar class="headr-main" position="static" sx={{ backgroundColor: 'white', display: 'flex' }}>
                <Toolbar>
                    <Grid ml={30} width={250}>
                        <AsyncSelect
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            isClearable={false}
                            defaultOptions
                            name='domain_name'
                            loadOptions={fetchProject}
                            getOptionLabel={(e) => e.name}
                            getOptionValue={(e) => e.id}
                            placeholder={'Domain Name'}
                            value={watch('domain_name')}
                            onInputChange={fetchProject}
                            onChange={handleUserSelect}
                        />
                    </Grid>
                    <Grid ml={5} width={250}>
                        <AsyncSelect
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            isClearable
                            defaultOptions
                            // loadOptions={fetchEmployees}
                            // getOptionLabel={(e) => e.name}
                            // getOptionValue={(e) => e.id}
                            placeholder={'Domain Version'}
                        // onChange={handleUserSelect}
                        />
                    </Grid>
                    {/* <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{ mr: 2 }}
                    >
                        <MenuIcon />
                    </IconButton> */}
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>

                    </Typography>
                    <Stack direction="row" spacing={2}>
                        <Avatar src={'https://www.spiderworks.in/theme/web/img/logo-sw.png'} sx={{ objectFit: 'cover' }} />
                    </Stack>
                </Toolbar>
            </AppBar>
        </Box >
    );
}
